import { environment } from './../../../../environments/environment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit, Input, Output, ViewChild, Inject, EventEmitter } from '@angular/core';
import { CustomersFilters } from '../../../model/customers';
import { DxDataGridComponent } from 'devextreme-angular';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomersService } from '../../../services/customers.service';
import { TrailerService } from '../../../services/trailers.service';
import { TrucksService } from '../../../services/trucks.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AttachmentsService } from '../../../services/attachments.service';
import { SetupDataService } from '../../../services/setupdata.service';
import { AttachmentsComponent } from '../../theme/attachments/attachments.component';
import { MatStepper } from '@angular/material/stepper';
import { TrucksFilters } from '../../../model/trucks';
import { DriversService } from '../../../services/driver.service';
import { DispatcherService } from '../../../services/dispatcher.service';
import { FuelcardService } from '../../../services/fuelcard.service';
import { DecimalPipe } from '@angular/common';
import { VendorService } from '../../../services/vendor.service';
import moment from 'moment';
import { CarrierService } from '../../../services/carrier.service';
import { UnitTypeService } from '../../../services/unit-type.service';
@Component({
  selector: 'app-carrier-creation-popup',
  templateUrl: './carrier-creation-popup.component.html',
  styleUrls: ['./carrier-creation-popup.component.scss'],
  providers: [CustomersService, TrucksService, TrailerService, DriversService, SetupDataService,CarrierService ]
})
export class CarrierCreationPopupComponent implements OnInit {
  searchType;
  searchVal='';
  public pageFilters :any= { companyname: "" };
  // Carrierlistdata = new Array<CarrierFilters>();
  contactdata = [];
  payratedata = [];
  driversafetydata = [];
  trucksafetydata = [];
  drugmedicaldata = [];
  carrierForm: FormGroup;
  // @Input() data;
  @Input() disableClose;
  @Output() newItemEvent = new EventEmitter<string>();
  @ViewChild('grid_contact',{ static: false ,read: DxDataGridComponent}) grid_contact: DxDataGridComponent;
  @ViewChild('grid_truck_safety',{ static: false ,read: DxDataGridComponent}) grid_truck_safety: DxDataGridComponent;
  @ViewChild('grid_driver_safety',{ static: false ,read: DxDataGridComponent}) grid_driver_safety: DxDataGridComponent;
  @ViewChild('grid_payrate',{ static: false ,read: DxDataGridComponent}) grid_payrate: DxDataGridComponent;
  @ViewChild('grid_medical',{ static: false ,read: DxDataGridComponent}) grid_medical: DxDataGridComponent;

  mode = false;
  finalArry = [];
  typeDetails = [
    {
      ID: 0,
      Name: "Carrier",
    },
    {
      ID: 1,
      Name: "Driver",
    },
    {
      ID: 2,
      Name: "Owner",
    },
  ];
  trucktypeDetails = [
    {
      ID: 0,
      Name: "Truck",
    },
    {
      ID: 1,
      Name: "Trailer",
    },
  ];
  paytypeDetails = [
    // {
    //   ID: 0,
    //   Name: "Per Hour",
    // },
    {
      ID: 1,
      Name: "Per Mile",
    },
    {
      ID: 2,
      Name: "Percentage(%)",
    },
  ];
  resultDetails = [
    {
      ID: 0,
      Name: "Pass",
    },
    {
      ID: 1,
      Name: "Fail",
    },
  ];
  statusDetails = [
    {
      ID: 0,
      Name: "Active",
    },
    {
      ID: 1,
      Name: "Inactive",
    },
  ];
  pageFiltersshow = false;
  submitted = false;
  contactinfodata = {};
  payrateinfodata = {};
  driversafetyAddObj = {};
  trucksafetyAddObj = {};
  drugdata = {};
  driverdata = [];
  hazmatDetails = [
    {
      ID: 0,
      Name: "Yes",
    },
    {
      ID: 1,
      Name: "No",
    },
  ];
  showAddOption = false;
  medicalcardexpiration = undefined;
  cdlexpirytate = undefined;
  fileArray = [];
  base64FileArray = [];
  item = "";
  filedata = {};
  showviewedit = false;
  selectedCarrier = true;
  showupdate = false;
  showsubmit = false;
  changeUplaod = true;
  editFileList = [];
  CarrierlistdataId;
  btnHide = false;
  driversafetydetails = undefined;

  SearchCountryField = SearchCountryField;

  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.India];
  selectedCellPhoneCountry = "US";
  selectedEmergencyPhoneCountry = "US";
  showGoogleAddress = "";
  todayDate;
  carrierId;
  today;
  submittedLast = false;
  companyType = "";
  unitTypes = [];
  dialogRefcust;
  custSearchList = []
  constructor(
    public dialogRef: MatDialogRef<CarrierCreationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _carrierService: CarrierService,
    private _trailersService: TrailerService,
    private _trucksservice: TrucksService,
    private _driverService: DriversService,
    private _toaster: ToastrService,
    private router: Router,
    public dialog: MatDialog,
    private _attachementService: AttachmentsService,
    private _unitTypeService: UnitTypeService,
    private _customersservice: CustomersService,
  ) { }

  ngOnInit() {
    this.companyType = localStorage.getItem("companyType");
    this.todayDate = new Date().toLocaleDateString("sv");
    this.today = new Date();
    if (this.data==null || this.data["EditMode"] == undefined) {
      this.mode = true;
      this.showAddOption = true;
      this.selectedCarrier = false;
      this.showsubmit = true;
      this.pageFilters["address"] = {};
      this.pageFilters["account"] = {};
    } else {
      this.mode = this.data["EditMode"];
      this.pageFilters = this.data;
      this.showAddOption = this.data["EditMode"];
      this.contactdata = this.data.contactinfo;
      this.payratedata = this.data.payrate;
      this.drugmedicaldata = this.data.drugdata;
      this.trucksafetydata = this.data.trucksafetyAddObj;
      this.driversafetydata = this.data.driversafetyAddObj;
      this.medicalcardexpiration = new Date(this.data["medicalcardexpiration"]);
      this.cdlexpirytate = new Date(this.data["cdlexpirytate"]);
      this.changeUplaod = false;
      this.fileArrayLocal = this.data["files"];
      if (this.data["hazmatcertified"]) {
        this.pageFilters["hazmatcertified"] = false;
      } else {
        this.pageFilters["hazmatcertified"] = true;
      }
      if (this.data["EditMode"]) {
        this.showupdate = true;
        this.editFileList = this.data["files"];
      }
      // if (this.pageFilters["dateofbirth"] != undefined || this.pageFilters["dateofbirth"] != null) {
      //   this.pageFilters["dateofbirth"] = moment(this.pageFilters["dateofbirth"]).format("YYYY-MM-DD");
      // }
      if (this.pageFilters["hiredate"] != undefined || this.pageFilters["hiredate"] != null) {
        this.pageFilters["hiredate"] = moment(this.pageFilters["hiredate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["terminationdate"] != undefined || this.pageFilters["terminationdate"] != null) {
        this.pageFilters["terminationdate"] = moment(this.pageFilters["terminationdate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["plateexpiry"] != undefined || this.pageFilters["plateexpiry"] != null) {
        this.pageFilters["plateexpiry"] = moment(this.pageFilters["plateexpiry"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["insuranceexpiry"] != undefined || this.pageFilters["insuranceexpiry"] != null) {
        this.pageFilters["insuranceexpiry"] = moment(this.pageFilters["insuranceexpiry"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["cdlexpirydate"] != undefined || this.pageFilters["cdlexpirydate"] != null) {
        this.pageFilters["cdlexpirydate"] = moment(this.pageFilters["cdlexpirydate"]).format("YYYY-MM-DD");
      }
      if (this.pageFilters["medicalcardexpiration"] != undefined || this.pageFilters["medicalcardexpiration"] != null) {
        this.pageFilters["medicalcardexpiration"] = moment(this.pageFilters["medicalcardexpiration"]).format("YYYY-MM-DD");
      }

      if (this.data["cellPhone"] != undefined) {
        this.selectedCellPhoneCountry = this.data["cellPhone"]["countryCode"];
      }
      if (this.data["cemergencyphone"] != undefined) {
        this.selectedEmergencyPhoneCountry = this.data["cemergencyphone"]["countryCode"];
      }
      if (this.data["googleAddress"] != undefined) {
        this.showGoogleAddress = this.data["googleAddress"]["fullAddress"];
      }
    }

    this.pageFiltersshow = true;
    this.getDriverData();
    this.getUnitTypes();
  }

  googleAddress;
  getGoogleAddress($event) {
    this.googleAddress = $event
    console.log(this.googleAddress);
  }

  getDriverData() {
    this._driverService.getDriversData().subscribe((data) => {
      this.driverdata = data.result.map((driver) => {
        return {
          ...driver,
          disabled: !driver.active
        }
      });
      console.log(this.driverdata);
    });
  }
  getUnitTypes() {
    let unitQuery = {};

    this._unitTypeService.getUnitTypes(unitQuery).subscribe((data) => {
      console.log("unit types list", data.result);
      this.unitTypes = data.result;
    });
  }

  hidePopup() {
    if (this.submitted) {
      this.submitClicked = false;
      this.dialogRef.close(true);
    } else {
      let companyName = localStorage
        .getItem("selectedCompanyName")
        .toLowerCase()
        .split(" ")
        .join("_");
      let formName = "Carrier";
      if (this.filesChanged) {
        if (this.showsubmit) {
          this.fileArrayLocal.forEach((item, index) => {
            this._attachementService
              .deleteFile(companyName, formName, item.fileName)
              .subscribe(
                (response) => { },
                (err) => {
                  this._toaster.error("Files deletion failed.", "Failed", {
                    timeOut: 1000,
                  });
                }
              );
          });
        }
        else if (this.showupdate) {
          let obj = {};
          obj["files"] = this.fileArrayLocal;
          this._carrierService.EditCarrier(obj, this.data["_id"]).subscribe(
            (res) => {
              this.btnHide = false;
              this.dialogRef.close(res);
            },
            (error) => {
              this._toaster.error("Carrier Data Not Updated", "Failed", {
                timeOut: 1000,
              });
              this.dialogRef.close(null);
            }
          );
        }
      }
      this.dialogRef.close(null);
    }
  }

  goBack() {
    this.dialogRef.close(null);
  }

  update(carrierForm) {
    // this.grid_contact.instance.saveEditData();
    this.grid_payrate.instance.saveEditData();
    // this.grid_driver_safety.instance.saveEditData();
    // this.grid_medical.instance.saveEditData();
    if (carrierForm.valid) {
      if(this.data["_id"] != undefined) {
        this.carrierId = this.data["_id"];
      }
      else{
        this.data["_id"] = this.carrierId;
      }
      this.data["files"] = this.fileArrayLocal;

      this.data["payrate"] = this.payratedata;
      this.data["drugdata"] = this.drugmedicaldata;
      this.data["trucksafetyAddObj"] = this.trucksafetydata;

      this.data["driversafetyAddObj"] = this.driversafetydata;
      this.data["contactinfo"] = this.contactdata;

      if (this.googleAddress != undefined) {
        this.data["googleAddress"] = this.googleAddress;
      }
      delete this.data["companyId"];
      delete this.data["createdAt"];
      delete this.data["updatedAt"];
      delete this.data["EditMode"];
      this.btnHide = true;
      this._carrierService.EditCarrier(this.data, this.data["_id"]).subscribe(
        (res) => {
          this._toaster.info("Carrier Data Updated successfully", "Success", {
            timeOut: 1000, closeButton: true
          });
          this.data["_id"] = this.carrierId;
          this.goBack();
          this.btnHide = false;
          this.dialogRef.close(res);
        },
        (error) => {
          this.data["_id"] = this.carrierId;
          this._toaster.error("Carrier Data Not Updated", "Failed", {
            timeOut: 1000,
          });
          this.dialogRef.close(null);
        }
      );

    } else {
     /*  this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 1000,
      }); */
      this.onFromValidation(carrierForm.controls)
    }
  }
  reset() { }
  submitClicked = false;

  submit(carrierForm) {
    // this.grid_contact.instance.saveEditData();
    this.grid_payrate.instance.saveEditData();
    // this.grid_driver_safety.instance.saveEditData();
    // this.grid_medical.instance.saveEditData();
    this.submitClicked = true;
    if (carrierForm.valid) {
      if (localStorage.selectedCompany == undefined) {
        this._toaster.error("Please Select Company", "Failed", {
          timeOut: 1000,
        });
      } else {
        var Carrierlistdata: any = this.pageFilters;

        Carrierlistdata["contactinfo"] = this.contactdata;
        Carrierlistdata["payrate"] = this.payratedata;
        Carrierlistdata["drugdata"] = this.drugmedicaldata;
        Carrierlistdata["driversafetyAddObj"] = this.driversafetydata;
        Carrierlistdata["trucksafetyAddObj"] = this.trucksafetydata;
        Carrierlistdata["companyId"] = localStorage.selectedCompany;

        var addobj = {};
        addobj["line"] = Carrierlistdata["address"]["line"];
        addobj["line1"] = Carrierlistdata["address"]["line1"];
        addobj["city"] = Carrierlistdata["address"]["city"];
        addobj["state"] = Carrierlistdata["address"]["state"];
        addobj["zip"] = Carrierlistdata["address"]["zip"];
        addobj["country"] = Carrierlistdata["address"]["country"];
        delete Carrierlistdata["line"];
        delete Carrierlistdata["line1"];
        delete Carrierlistdata["city"];
        delete Carrierlistdata["state"];
        delete Carrierlistdata["zip"];
        delete Carrierlistdata["country"];
        Carrierlistdata["address"] = addobj;

        var account = {};
        account["bankname"] = Carrierlistdata["account"]["bankname"];
        account["accountnumber"] = Carrierlistdata["account"]["accountnumber"];
        account["acctype"] = Carrierlistdata["account"]["acctype"];

        if (this.googleAddress != undefined) {
          Carrierlistdata["googleAddress"] = this.googleAddress;
        }

        delete Carrierlistdata["accountnumber"];
        delete Carrierlistdata["bankname"];
        delete Carrierlistdata["acctype"];
        // //delete Carrierlistdata["companyId"];

        Carrierlistdata["account"] = account;
        console.log(account);
        Carrierlistdata["files"] = this.fileArrayLocal;
        Carrierlistdata["_id"] = this.CarrierlistdataId;
        this.submittedLast = true;
            this._carrierService.SendForm(Carrierlistdata).subscribe(
              (response) => {
                if (response.status == "error") {
                  this._toaster.error(response.error, "Failed", {
                    timeOut: 1000,
                  });
                  this.btnHide = false;
                  this.submittedLast = false;
                } else {

                  this.submittedLast = true;
                  this._toaster.info("Carrierform Data Submitted", "Success", {
                    timeOut: 1000,
                  });
                  this.goBack();
                  this.btnHide = false;
                  this.submittedLast = false;
                  this.CarrierlistdataId = response["result"]["_id"];
                  console.log(this.CarrierlistdataId);
                  this.dialogRef.close(response);
                }
              },
              (error) => {
                this.submittedLast = false;
                if (error._body.includes("email")) {
                  this._toaster.error(JSON.parse(error._body).error, "Failed", { timeOut: 1000 });
                } else {
                  this._toaster.error("Something went wrong. Try again!!", "Failed", { timeOut: 1000 });
                }
              }
            );

        // } else {
        //   this._toaster.error("Enter SSN Details", "Failed", { timeOut: 1000 });
        // }
        console.log(this.pageFilters);
      }
    } else {
      /* this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 1000,
      }); */
      this.onFromValidation(carrierForm.controls)
    }
  }
  submitpart1(carrierForm, stepper:MatStepper) {
    this.submitClicked = true;

    if (carrierForm.valid) {
      if (localStorage.selectedCompany == undefined) {
        this._toaster.error("Please Select Company", "Failed", {
          timeOut: 1000,
        });
      } else {
        var Carrierlistdata: any = this.pageFilters;
        Carrierlistdata["companyId"] = localStorage.selectedCompany;
        Carrierlistdata["files"] = this.fileArrayLocal;
        if (this.googleAddress != undefined) {
          Carrierlistdata["googleAddress"] = this.googleAddress;
        }
        if (this.pageFilters["fullName"] === null) {
          this.pageFilters["fullName"] = "";
        }
        this.btnHide = true;
        this.submitted = true;
        this._carrierService.SendForm(Carrierlistdata).subscribe(
          (response) => {
            if (response.Status == "error") {
              this._toaster.error(response.error, "Failed", {
                timeOut: 1000,
              });
              this.btnHide = false;
            } else {
              this.submitted = true;
              stepper.selectedIndex = stepper.selectedIndex+1;
              // stepper.linear = true;
              this._toaster.info(
                "Carrierform Data Submitted",
                "Success",
                {
                  timeOut: 1000,
                }
              );
              this.btnHide = false;
              this.CarrierlistdataId = response["result"]["_id"];
              console.log(this.CarrierlistdataId);
            }
          },
          (error) => {
            this.submitted = false;
            // this._toaster.error("Submit Again", "Failed", {
            //   timeOut: 1000,
            // });

            if (error._body.includes("email")) {
              this._toaster.error(JSON.parse(error._body).error, "Failed", { timeOut: 1000 });
            } else {
              this._toaster.error("Something went wrong. Try again!!", "Failed", { timeOut: 1000 });
            }
          }
        );
      }
    } else {
      this._toaster.error("Please fix the validations", "Failed", {
        timeOut: 1000,
      });
    }
  }

  addRow(val){
    switch (val){
      case 'grid_contact':
        this.grid_contact.instance.addRow();
        this.grid_contact.instance.deselectAll();
        break;
      case 'grid_truck_safety':
        this.grid_truck_safety.instance.addRow();
        this.grid_truck_safety.instance.deselectAll();
        break;
      case 'grid_driver_safety':
        this.grid_driver_safety.instance.addRow();
        this.grid_driver_safety.instance.deselectAll();
        break;
      case 'grid_payrate':
        this.grid_payrate.instance.addRow();
        this.grid_payrate.instance.deselectAll();
        break;
      case 'grid_medical':
        this.grid_medical.instance.addRow();
        this.grid_medical.instance.deselectAll();
        break;
    }
  }
  onFromValidation(formData) {
    let check = false;
    let timeout = 3000;
    Object.keys(formData).forEach((key) => {
      if (check) {
        return;
      }
      if (formData[key].errors) {
        if (key === "companyname") {
          this._toaster.error("Company name is Required", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if (key === "dotnumber") {
          if (formData[key].errors.pattern) {
            this._toaster.error("DOT Number Only numbers are allowed", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.required){
            this._toaster.error("DOT Number is Required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "cellphone") {
          if(formData[key].errors.validatePhoneNumber){
            this._toaster.error("Cell phone is invalid", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.required){
            this._toaster.error("Cell phone is Required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        } else if (key === "cemergencyphone") {
          if(formData[key].errors.validatePhoneNumber){
            this._toaster.error("Emergency phone is invalid", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.required){
            this._toaster.error("Emergency phone is Required", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "email") {
          this._toaster.error("Email ID is invalid", "Failed",{
              timeOut: timeout,
            });
          check = true;
        }
        else if (key === "fullName") {
          if(formData[key].errors.pattern){
            this._toaster.error("Full Name - Only Alphanumeric values are allowed", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.maxLength){
            this._toaster.error("Full Name - Max of 50 characters are allowed", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        // else if (key === "dateofbirth") {
        //   this._toaster.error("Please enter a valid date of birth", "Failed", {
        //     timeOut: timeout,
        //   });
        //   check = true;
        // }
        else if (key === "ssn") {
          if(formData[key].errors.pattern){
            this._toaster.error("SSN - Only numbers are allowed", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.maxLength || formData[key].errors.minlength){
            this._toaster.error("SSN/Tax ID must be of 9 digits", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "hiredate") {
          this._toaster.error("Please enter a valid hire date", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if (key === "terminationdate") {
          this._toaster.error("Please enter a valid termination date", "Failed", {
            timeOut: timeout,
          });
          check = true;
        }
        else if (key === "vendoraccount") {
          if(formData[key].errors.pattern){
            this._toaster.error("Vendor Account - Only numbers are allowed", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.maxLength) {
            this._toaster.error("Vendor Account Max of 10 characters are allowed", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "accountnumber") {
          if(formData[key].errors.pattern){
            this._toaster.error("Account Number - Only numbers are allowed", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else if (key === "routingnumber") {
          if(formData[key].errors.pattern){
            this._toaster.error("Routing Number - Only numbers are allowed", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
          else if(formData[key].errors.maxLength || formData[key].errors.minlength) {
            this._toaster.error("Routing Number can't exceed 9 digits", "Failed", {
              timeOut: timeout,
            });
            check = true;
          }
        }
        else {
          this._toaster.error("Please fix the validations", "Failed", {
            timeOut: 1000,
          });
          check = true;
        }
      }
    });
  }

  filesChanged = false;
  fileArrayLocal = [];
  attachementData = {};
  openAttachments() {
    this.attachementData["fileInfo"] = this.fileArrayLocal;
    if (this.showsubmit || this.showupdate) {
      this.attachementData["mode"] = true;
    }
    this.attachementData["model"] = "Carrier";
    let dialogConfig = Object.assign(
      { width: "1000px" },

      { data: this.attachementData },
      { disableClose: true }
    );
    let dialogRef = this.dialog.open(AttachmentsComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((attachmentData) => {
      this.fileArrayLocal = attachmentData.fileInfo;
      this.filesChanged = attachmentData.filesChanged;
    });
  }
  onChangeDate(event, formData){
    Object.keys(formData.controls).forEach((key) => {
      switch (key) {
        // case 'dateofbirth':
        //   if(new Date(formData.controls[key].value) > new Date(this.todayDate)){
        //     formData.controls[key].setErrors({dateError: "invalid date"});
        //   }
        //   break;
        case 'hiredate':
          if(new Date(formData.controls[key].value) > new Date(this.todayDate)){
            formData.controls[key].setErrors({dateError: "invalid date"});
          }
          break;
        case 'terminationdate':
          if(new Date(formData.controls[key].value) < new Date(this.todayDate)){
            formData.controls[key].setErrors({dateError: "invalid date"});
          }
          break;

        default:
          break;
      }
    })
  }
  gridBox_displayUnittypeExpr(data) {
    return data && data?.truckType + " - " + data?.slNo;
  }
  searchCust(comp){
    this._customersservice.getCustomersfmcsaData(this.searchType, this.searchVal).subscribe(
      (res) => {

        console.log(res);
        // this.dialogRef.close(res);
        if(res.result.content.length == 1){
          const custdet = res.result.content[0]
          this.pageFilters.companyname = custdet.legalName
          this.pageFilters.dotnumber = String(custdet.dotNumber)
          // this.showCustomerGoogleAddress =  `${custdet?.phyCity}, ${custdet?.phyState}, ${custdet?.phyZipcode}`
          // this.pageFilters.CustomerAddress =  {
          //   fullAddress: this.showCustomerGoogleAddress,
          //   latitude: 0,
          //   longitude: 0,
          // }
          this._toaster.info("Customer Data Found", "Found", {
            timeOut: 10000,
          });
        }
        else if(res.result.content.length > 1){
         this.dialogRefcust =  this.dialog.open(comp,{});
         this.custSearchList =  res.result.content
        }
        else{
          this._toaster.error("Customer Data Not Found", "Failed", {
            timeOut: 10000,
          });
        }
      },
      (error) => {
        this._toaster.error("Customer Data Not Found", "Failed", {
          timeOut: 1000,
        });
      }
    );
  }
  selectCust(obj){
    this.pageFilters.companyname = obj.legalName
    this.pageFilters.dotnumber = String(obj.dotNumber)
    // this.showCustomerGoogleAddress =  `${obj?.phyCity}, ${obj?.phyState}, ${obj?.phyZipcode}`
    //  this.pageFilters.CustomerAddress =  {
    //   fullAddress: this.showCustomerGoogleAddress,
    //   latitude: 0,
    //   longitude: 0,
    // }
    this._toaster.info("Carrier Data Selected", "Selected", {
      timeOut: 10000,
    });
    this.closeCust();
  }
  closeCust(){
    this.dialogRefcust.close();
  }
}

